import { createPortal } from "react-dom";
import useIsDesktop from "@/lib/useIsDesktop";

// DESKTOP DUAL-PANE PRIMITIVE.
// Lifts a full-screen view OUT of the 1/3 phone chassis and docks it into the
// right-hand 2/3 Dynamic Workspace Pane. It portals to <body> so it escapes the
// chassis CSS transform, and the `translateZ(0)` on the pane establishes a
// containing block so BOTH `absolute inset-0` AND `fixed inset-0` children are
// contained inside the 2/3 pane (never the full viewport).
//
// On mobile (<lg) it renders `children` exactly in place — the mobile layout is
// 100% untouched.
export default function DesktopEscape({ children, z = "z-[50]", testid }) {
  const isDesktop = useIsDesktop();
  if (!isDesktop) return children;
  return createPortal(
    <div
      data-testid={testid}
      className={`hidden lg:block fixed top-0 bottom-0 right-0 ${z} bg-black`}
      style={{ left: "508px", transform: "translateZ(0)" }}
    >
      <div className="relative h-full w-full overflow-hidden">{children}</div>
    </div>,
    document.body
  );
}
